import React from "react";

import ResizeHandleImg from "assets/images/icons/ResizeHandle.png";

const ResizeHandle = React.forwardRef<HTMLDivElement>((props, ref) => (
  <div
    {...props}
    ref={ref}
    className="react-resizable-handle"
    style={{
      position: "absolute",
      width: "20px",
      height: "20px",
      bottom: 0,
      right: 0,
      cursor: "se-resize",
      backgroundImage: "none",
    }}
  >
    <img
      style={{ width: 9, height: 9, objectFit: "contain", position: "relative", bottom: 3, left: 2 }}
      src={ResizeHandleImg}
      alt="resize-handle"
    />
  </div>
));
export default ResizeHandle;
